import IconFlagBg from "assets/icons/flags/bg.svg";
import IconFlagDa from "assets/icons/flags/da.svg";
import IconFlagDe from "assets/icons/flags/de.svg";
import IconFlagEn from "assets/icons/flags/en.svg";
import IconFlagEsp from "assets/icons/flags/esp.svg";
import IconFlagEst from "assets/icons/flags/est.svg";
import IconFlagFi from "assets/icons/flags/fi.svg";
import IconFlagFr from "assets/icons/flags/fr.svg";
import IconFlagIt from "assets/icons/flags/it.svg";
import IconFlagLt from "assets/icons/flags/lt.svg";
import IconFlagLv from "assets/icons/flags/lv.svg";
import IconFlagNl from "assets/icons/flags/nl.svg";
import IconFlagPol from "assets/icons/flags/pol.svg";
import IconFlagRo from "assets/icons/flags/ro.svg";
import IconFlagRu from "assets/icons/flags/ru.svg";
import IconFlagSwe from "assets/icons/flags/swe.svg";
import { ReactNode } from "react";

export const mapLanguageKeyToFlagIcon: Record<string, ReactNode> = {
  en: <IconFlagEn width={30} height={20} />,
  ru: <IconFlagRu width={30} height={20} />,
  de: <IconFlagDe width={30} height={20} />,
  es: <IconFlagEsp width={30} height={20} />,
  ee: <IconFlagEst width={30} height={20} />,
  pl: <IconFlagPol width={30} height={20} />,
  se: <IconFlagSwe width={30} height={20} />,
  nl: <IconFlagNl width={30} height={20} />,
  fi: <IconFlagFi width={30} height={20} />,
  da: <IconFlagDa width={30} height={20} />,
  it: <IconFlagIt width={30} height={20} />,
  fr: <IconFlagFr width={30} height={20} />,
  ro: <IconFlagRo width={30} height={20} />,
  lt: <IconFlagLt width={30} height={20} />,
  lv: <IconFlagLv width={30} height={20} />,
  bg: <IconFlagBg width={30} height={20} />,
};

export const selectNationalFlag = (language: string) => {
  return mapLanguageKeyToFlagIcon[language];
};
